import { IJsonQueryRegionalDistrict } from '../../../packages/api-models/common/json_query';
import { TGeoValue } from '../../../packages/JsonQuery';

export function addRegionalDistrictToJsonQuery(geoValue: TGeoValue[] | null, id: number): TGeoValue[] {
  const regionalDistrictItem: IJsonQueryRegionalDistrict = { id, type: 'regional_district_id' };

  return geoValue ? [...geoValue, regionalDistrictItem] : [regionalDistrictItem];
}
